export const userAccountSections = [
    {
        id: 'overview',
        href: '/account/overview',
        translationKey: 'account.overview',
        defaultDisplayName: 'Overview',
    },
    {
        id: 'rewards',
        href: '/account/rewards',
        translationKey: 'account.rewards',
        defaultDisplayName: 'Rewards',
    },
    // {
    //     id: 'sessions',
    //     href: '/account/sessions',
    //     translationKey: 'account.sessions',
    //     defaultDisplayName: 'Sessions',
    // },
    {
        id: 'profile',
        href: '/account/profile',
        translationKey: 'account.profile',
        defaultDisplayName: 'Profile',
    },
    {
        id: 'settings',
        href: '/account/settings',
        translationKey: 'account.settings',
        defaultDisplayName: 'Settings',
    },
    {
        id: 'transactions',
        href: '/account/transactions',
        translationKey: 'account.transactions',
        defaultDisplayName: 'Transactions',
    },
    {
        id: 'verification',
        href: '/account/verification',
        translationKey: 'account.verification',
        defaultDisplayName: 'Verification',
    },
    {
        id: 'responsible-gaming',
        href: '/account/responsible-gaming/sports-budget-limits',
        translationKey: 'account.responsible-gaming',
        defaultDisplayName: 'Limits',
    },
];
